

































import { Component, Mixins } from "vue-property-decorator";
import { SurchargeStore } from "@/mixins/surcharge";

/** FUMBSD-761: rate and date come from the API (GET /prices/surcharge) */
@Component
export default class PriceSurchargeModal extends Mixins(SurchargeStore) {
  get surchargeValue(): string {
    return this.surcharge.label || "0%";
  }

  get surchargeDate(): string {
    return this.surcharge.effective_date || "";
  }
  protected closeModal(): void {
    this.$emit("close");
  }
}
